module.exports = __webpack_public_path__ + "img/tenderreject.e6a3fda5.png";